







































































































import { Component, Vue } from 'vue-property-decorator'
import PublishTopic from './PublishTopic.vue'
import Topic from './Topic.vue'
import { queryDictsByCode, getTopic, addTopic } from '@/api/api'
var E = require('wangeditor')

@Component({
  components: {
    PublishTopic,
    Topic
  }
})
export default class HotspotList extends Vue {
  userInfo: any = '' // 用户信息
  activeIndex: string = '' // 默认选择全部
  displayType: string = '0' // 0显示看点内容，1显示发表页, 2显示看点的评论
  infoList: Array<object> = [] // 看点列表
  topicTypeList: Array<object> = [] // 看点类型
  topicInfo: string = '' // 选中的看点
  total: number = 0 // 看点数量
  pageSize: number = 10 // 分页组件的page-size

  mounted() {
    this.userInfo = JSON.parse(sessionStorage.userInfo)
    this._onload()
  }

  /**
   * 选择tab页
   */
  tabSelect(e: any): void {
    this.activeIndex = e.name
    this._getTopic(e.name, 1)
  }

  /**
   * 切换显示内容
   */
  toggleDisplayType(e: string): void {
    this.displayType = e
  }

  /**
   * 打开评论
   */
  openComment(topicInfo: any): void {
    this.topicInfo = topicInfo
    this.toggleDisplayType('2')
  }

  /**
   * 前往我的帖子
   */
  toMyPost(): void {
    this.$router.replace({ path: '/PersonalCenter', query: { menuIndex: '3' } })
  }

  /**
   * 换页
   */
  async changePage(page: number): Promise<any> {
    this._loading()
    await this._getTopic(this.activeIndex, page)
    this._loading().close()
  }

  /**
   * 页面初始化
   */
  async _onload(): Promise<any> {
    this._loading()

    await this._queryDictsByCode()

    await this._getTopic('', 1)
  }

  /**
   * 获取看点类型
   */
  _queryDictsByCode(): void {
    queryDictsByCode({
      parent_code: 'topic'
    }).then((res: any) => {
      this.topicTypeList = res.data.result
    })
  }

  /**
   * 获取看点
   * @param type_code 话题类型 全部（传空）影视（movies）书籍（books）热点（hotspot）八卦（unofficial）我有话说（talk）
   * @param page      页码
   * @param size      数量
   */
  _getTopic(type_code: string, page: number = 1, size: number = this.pageSize): void {
    this._loading()
    getTopic({
      type_code,
      page,
      size
    })
      .then((res: any) => {
        this._loading().close()
        if (res.data.code === 101) {
          this.infoList = res.data.result.records
          this.total = res.data.result.total
        }
      })
      .catch(_ => {
        this._loading().close()
      })
  }

  /**
   * 显示loading
   */
  _loading(): any {
    const vm = this
    this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    return {
      close() {
        vm.$loading({}).close()
      }
    }
  }
}
